module.exports = __webpack_public_path__ + "media/images/refresh-f873dfeb.png";